import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  containerPaddingMobile: {
    ...shorthands.padding(tokens.spacingVerticalXL, tokens.spacingHorizontalM),
  },
  containerPaddingDesktop: {
    ...shorthands.padding(tokens.spacingVerticalXL, tokens.spacingHorizontalNone),
  },
  title: {
    fontSize: tokens.fontSizeBase600,
    fontWeight: tokens.fontWeightBold,
    lineHeight: tokens.lineHeightBase600,
    gridColumn: '1 / -1',
    justifySelf: 'start',
  },
  grid: {
    display: 'grid',
    placeItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalL,
    gridTemplateColumns: 'repeat(auto-fit, 346px)',
  },
  card: {
    boxSizing: 'border-box',
    padding: tokens.spacingVerticalXXL,
  },
});
